import { request } from '@/api/client';
import type {
  FavoritesListResponse,
  FavoriteActionRequest,
  FavoriteActionResponse,
} from '@/types/favorites';

/** Favorite-echo endpoints — add, remove, list. */
export const favoriteService = {
  add: (echoId: string): Promise<FavoriteActionResponse> =>
    request<FavoriteActionResponse>('/favorites/add', {
      method: 'POST',
      body: JSON.stringify({ echo_id: echoId } as FavoriteActionRequest),
      auth: true,
    }),

  remove: (echoId: string): Promise<FavoriteActionResponse> =>
    request<FavoriteActionResponse>('/favorites/remove', {
      method: 'DELETE',
      body: JSON.stringify({ echo_id: echoId } as FavoriteActionRequest),
      auth: true,
    }),

  list: (): Promise<FavoritesListResponse> =>
    request<FavoritesListResponse>('/favorites/list', {
      method: 'GET',
      auth: true,
    }),

  check: (echoId: string): Promise<FavoriteActionResponse> =>
    request<FavoriteActionResponse>(`/favorites/check/${encodeURIComponent(echoId)}`, {
      method: 'GET',
      auth: true,
    }),
};
